import React from "react";

import { ProductStackTile } from "./ProductStackTile";

export function ProductStack() {
  return (
    <>
      <group scale={0.9}>
        <ProductStackTile layer={3} />
        <ProductStackTile layer={2} />
        <ProductStackTile layer={1} />
        <ProductStackTile layer={0} />
      </group>
      <ambientLight intensity={3} />
      <directionalLight
        intensity={3}
        position={[0, 0, 5]}
        color="white"
        lookAt={[0, 0, 0]}
      />
    </>
  );
}
